export const loginLimitErrorType = 'TOO_MANY_ACTIVE_LOGINS';
export const supportCenterLink = 'https://service.elsevier.com/app/home/supporthub/reaxys/';
